import { MyAxios, handleError, handleResponse } from '@app/services/SettingAxios';
import { TypeMarkInfo } from '../types/fitsTheAutoSchema';
import { DisksParamQueryDto } from './api.dto';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchFetMarksByParamDisks = createAsyncThunk<{ [key: string]: TypeMarkInfo[] }, DisksParamQueryDto>(
  'fitsTheAuto/fetchFetMarksByParamDisks',
  async query => {
    return await MyAxios.get(
      '/api/product/disks-suitable-for-car' +
        `?width=${query.width}&diam=${query.diam}&pcdc=${query.pcdc}&pcdd=${query.pcdd}&dia=${query.dia}&et=${query.et}`,
    )
      .then(handleResponse)
      .catch(handleError);
  },
);
